import axios from 'axios';
import { JSEncrypt } from 'jsencrypt';
import { clearUnifiedAuth, saveUnifiedAuth } from './session';

export const UNIFIED_LOGIN_URLS = {
  sendVerifyCode: '/client-bff/web/open/unified/login/sendVerifyCode',
  key: '/client-bff/web/open/unified/login/key',
  sms: '/client-bff/web/open/unified/login/sms',
};

// 独立实例不继承基座的 token 注入、过期跳转和 POST 异常吞掉逻辑。
const client = axios.create({ timeout: 20000 });

const request = async (url, method, payload) => {
  const curEnv = process.env.NODE_ENV === 'development' ? localStorage.getItem('curEnv') : '';
  const headers = { 'X-Auth-AppId': '10016' };
  // 泳道由部署配置指定，不能将开发泳道带入其他环境。
  if (process.env.VUE_APP_UNIFIED_LOGIN_ENV) headers.env = process.env.VUE_APP_UNIFIED_LOGIN_ENV;
  const response = await client({
    baseURL: `/boss${curEnv ? `/${curEnv}` : ''}`,
    url,
    method,
    headers,
    ...(method === 'get' ? { params: payload } : { data: payload }),
  });
  const result = response.data;
  if (!result || String(result.errCode) !== '0') {
    throw new Error((result && result.message) || '统一登录接口请求失败');
  }
  return result.data;
};

const validatePhone = (phone) => {
  if (!/^1[3-9][0-9]{9}$/.test(phone)) throw new Error('手机号码格式不正确');
};

const createRequestId = () => {
  const bytes = new Uint8Array(16);
  window.crypto.getRandomValues(bytes);
  bytes[6] = (bytes[6] & 15) | 64; // eslint-disable-line no-bitwise
  bytes[8] = (bytes[8] & 63) | 128; // eslint-disable-line no-bitwise
  const hex = Array.from(bytes, (value) => value.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
};

export const sendUnifiedVerifyCode = async (phone) => {
  validatePhone(phone);
  const codeId = await request(UNIFIED_LOGIN_URLS.sendVerifyCode, 'get', { phone });
  if (typeof codeId !== 'string' || !codeId) throw new Error('验证码接口未返回 codeId');
  return codeId;
};

let loginPending = false;
export const loginUnifiedSms = async ({ phone, verifyCode, codeId }) => {
  if (loginPending) throw new Error('正在登录，请勿重复提交');
  validatePhone(phone);
  if (!/^\d{6}$/.test(verifyCode) || typeof codeId !== 'string' || !codeId) {
    throw new Error('请获取并填写有效验证码');
  }
  loginPending = true;
  const loginEnv = localStorage.getItem('curEnv') || '';
  const loginAppId = localStorage.getItem('appId') || '';
  clearUnifiedAuth();
  try {
    const publicKey = await request(UNIFIED_LOGIN_URLS.key, 'post', {});
    if (typeof publicKey !== 'string' || !publicKey) throw new Error('未获取到登录公钥');
    const encryptor = new JSEncrypt();
    encryptor.setPublicKey(publicKey);
    const encryptedPhone = encryptor.encrypt(phone);
    const encryptedCode = encryptor.encrypt(verifyCode);
    if (!encryptedPhone || !encryptedCode) throw new Error('登录信息加密失败');
    if (loginEnv !== (localStorage.getItem('curEnv') || '')
      || loginAppId !== (localStorage.getItem('appId') || '')) {
      throw new Error('登录环境已切换，请重新登录');
    }
    // 一次提交一个 requestId，不自动重试可能已消费验证码的请求。
    const data = await request(UNIFIED_LOGIN_URLS.sms, 'post', {
      phone: encryptedPhone,
      verifyCode: encryptedCode,
      codeId,
      requestId: createRequestId(),
    });
    if (loginEnv !== (localStorage.getItem('curEnv') || '')
      || loginAppId !== (localStorage.getItem('appId') || '')) {
      throw new Error('登录环境已切换，请重新登录');
    }
    return saveUnifiedAuth(data);
  } finally {
    loginPending = false;
  }
};
